import { getAuthToken } from "../services/authStorage";
/**
 * Auto-refresh configuration
 * Controls when and how often the app should auto-refresh data
 */

export const AUTO_REFRESH_CONFIG = {
  // Enable/disable auto-refresh globally
  ENABLED: true,

  // Minimum interval between auto-refreshes (in minutes)
  DEFAULT_INTERVAL: 2,

  // Intervals for different scenarios
  INTERVALS: {
    HOME_FEED: 2, // Home feed refresh interval
    GROUP_FEED: 3, // Group feed refresh interval
    NOTIFICATIONS: 1, // Notifications refresh interval
    DIARY: 5, // Diary refresh interval
    MENU: 10, // Menu refresh interval
  },

  // Conditions for auto-refresh
  CONDITIONS: {
    // Only refresh if app was inactive for at least this time (in minutes)
    MIN_INACTIVE_TIME: 0.5, // Reduced to 30 seconds for easier testing

    // Only refresh if user is authenticated
    REQUIRE_AUTH: true,

    // Only refresh on specific pages
    ENABLED_PAGES: [
      "/home",
      "/gruppi",
      "/notifiche",
      "/il-tuo-percorso",
      "/misure-e-progressi",
      "/preferenze-nutrizionali",
      "/il-mio-percorso",
      "/diario",
      "/menu",
    ],
  },

  // Debug options
  DEBUG: {
    LOG_REFRESH_EVENTS: true,
    LOG_APP_STATE_CHANGES: true,
  },
};

/**
 * Check if auto-refresh should be enabled for current page
 * @param {string} currentPath - Current page path
 * @returns {boolean} Whether auto-refresh should be enabled
 */
export const shouldEnableAutoRefresh = (currentPath) => {
  if (!AUTO_REFRESH_CONFIG.ENABLED) return false;

  // Check if current page is in enabled pages list
  return AUTO_REFRESH_CONFIG.CONDITIONS.ENABLED_PAGES.some((page) =>
    currentPath.startsWith(page),
  );
};

/**
 * Get refresh interval for specific page type
 * @param {string} pageType - Type of page (HOME_FEED, GROUP_FEED, etc.)
 * @returns {number} Refresh interval in minutes
 */
export const getRefreshInterval = (pageType) => {
  return (
    AUTO_REFRESH_CONFIG.INTERVALS[pageType] ||
    AUTO_REFRESH_CONFIG.DEFAULT_INTERVAL
  );
};

/**
 * Check if user is authenticated (for auto-refresh conditions)
 * @returns {boolean} Whether user is authenticated
 */
export const isUserAuthenticated = () => {
  return !!getAuthToken();
};
